import React from 'react';
import {connect} from "react-redux";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "material-ui";
import {closeDeleteTaskFetch, deleteTask} from "../../../redux/actions/tasks";
import {snackMessageShow} from "../../../redux/actions/snack_message";

export class TaskDeleteDialog extends React.Component {

    onClickSubmit = () => {
        this.props.deleteTask(this.props.task, () => {
            this.props.handleClose();
        });
    };

    render() {

        const {open, handleClose} = this.props;

        return (
            <Dialog
                open={open}>

                <DialogTitle>
                    課題の削除
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        選択した課題を削除します。<br/>
                        この操作で削除されたデータは、復旧することができません。<br/>
                        また、この課題に関する全ての情報が削除されます。
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="default">
                        キャンセル
                    </Button>
                    <Button onClick={this.onClickSubmit.bind(this)} color="primary" autoFocus>
                        削除する
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

TaskDeleteDialog = connect(
    (state) => {
        return {
            task: state.tasks.task,
        }
    },
    (dispatch) => {
        return {
            deleteTask: (regulation, callback) => {
                dispatch(deleteTask(regulation)).then((response) => {
                    setTimeout(() => {
                        dispatch(closeDeleteTaskFetch());
                        switch (response.type) {
                            case 'API_DELETE_TASK_FAIL':
                                dispatch(snackMessageShow('課題の削除に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('課題を削除しました'));
                                callback();
                        }
                    }, 200);
                });
            },
        }
    }
)(TaskDeleteDialog);


// WEBPACK FOOTER //
// ./src/containers/task/dialog/delete.js